import React from 'react'
import { ContactUsCss } from './Style'
import { Form } from 'components/Form'
import { FlexCenter } from 'styles/GlobalStyle'
import { AuthWithCartoon } from 'pages/Auth'
import Go3 from 'assets/Go3.png'
import contactUs from './hooks'
import { validate } from './Validate'

const CreateTicket = () => {
    const { formname, title } = contactUs.constants

    const fields = contactUs.useFormFields()
    const submitBtn = contactUs.useSubmitBtn()

    const email = { name: "email", component: "input", placeholder: "המייל שלכם", fullWidth: true, }

    return (
        <FlexCenter>
            <AuthWithCartoon hideAuthTab={true} cartoon={Go3}>
                <Form
                    title={title}
                    csswrap={ContactUsCss}
                    fields={[...fields, email]}
                    submit={() => { }}
                    form={formname}
                    validations={validate}
                    submitBtns={[submitBtn]}
                />
            </AuthWithCartoon>
        </FlexCenter>
    )
}

export default CreateTicket